import ProductionTaskPage from "@/pages/ProductionTaskPage";

export default function BakerTask() {
  return <ProductionTaskPage role="baker" design="delivery" />;
}
